(function ($) {
  function submitFormNewsLetter(form) {
    const fields = [];

    const $input_email = $('input[name="email-newsletter"]', form);

    if ($input_email) {
      fields.push({
        objectTypeId: "0-1",
        name: "email",
        value: $input_email.val(),
      });
    }

    const data = {
      submittedAt: Date.now(),
      fields: fields,
      context: {
        // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
        hutk: typeof __hsUserToken !== "undefined" ? __hsUserToken : "",
        pageUri: window.location.href,
        pageName: document.title + " - Newsletter",
      },
    };

    // console.log("form submit data", data);

    /*
https://share-eu1.hsforms.com/1pgCc2HweSNamD48khlJTCQ2b6xoj

<script charset="utf-8" type="text/javascript" src="//js-eu1.hsforms.net/forms/embed/v2.js"></script>
<script>
  hbspt.forms.create({
    region: "eu1",
    portalId: "139731715",
    formId: "a6009cd8-7c1e-48d6-a60f-8f2486525309"
  });
</script>
*/

    $.ajax({
      type: "POST",
      url: "https://api.hsforms.com/submissions/v3/integration/submit/26122002/528ec6e7-6401-4815-a68a-269c23881406",
      // The key needs to match your method's input parameter (case-sensitive).
      data: JSON.stringify(data),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function (data) {
        const formFields = form.find(".ci-Footer-form-fields");
        const afterCompletion = form.find(".after-completion");

        if (formFields.length) {
          formFields.addClass("hidden");
        }
        if (afterCompletion.length) {
          afterCompletion.removeClass("hidden");
          afterCompletion.text(data.inlineMessage);
        }

        // GTM Tracking
        if (typeof gtm_datalayer_push == "function") {
          gtm_datalayer_push({
            event: "newsletter_subscription",
          });
        }
      },
      error: function (errMsg) {
        console.error(errMsg);
      },
    });
  }

  let $ci_form_footer_newsletter = $("form#ci-Footer-newsletter");

  if ($ci_form_footer_newsletter) {
    $ci_form_footer_newsletter.on("submit", function (event) {
      // $(".ci-Footer-formSubmit", $ci_form_footer_newsletter).on("click", function (event) {
      event.preventDefault();

      // console.log("footer form click");

      submitFormNewsLetter($ci_form_footer_newsletter);

      return false;
    });
  }
})(jQuery);
